import React, { Component } from 'react';
import { connect } from 'react-redux';
import './GoalComponent.css';

// Import SVG tag icons - matching reference project exactly
import { ReactComponent as CogColorIcon } from '../../assets/icons/goal-tag/cog-color.svg';
import { ReactComponent as FmColorIcon } from '../../assets/icons/goal-tag/fm-color.svg';
import { ReactComponent as GmColorIcon } from '../../assets/icons/goal-tag/gm-color.svg';
import { ReactComponent as PsColorIcon } from '../../assets/icons/goal-tag/ps-color.svg';
import { ReactComponent as PwColorIcon } from '../../assets/icons/goal-tag/pw-color.svg';
import { ReactComponent as SeColorIcon } from '../../assets/icons/goal-tag/se-color.svg';
import { ReactComponent as ShColorIcon } from '../../assets/icons/goal-tag/sh-color.svg';
import { ReactComponent as SlColorIcon } from '../../assets/icons/goal-tag/sl-color.svg';

interface GoalComponentProps {
  id: number;
  currentSettings?: any;
  navigate?: (screen: string, params?: any) => void;
}

interface GoalComponentState {
  tag: string;
  attempts: any;
  description: string;
}

class GoalComponent extends Component<GoalComponentProps, GoalComponentState> {
  constructor(props: GoalComponentProps) {
    super(props);
    
    // Get goal data from current settings
    const goal = props.currentSettings?.child?.goals?.find((obj: any) => obj.id === props.id);
    
    this.state = {
      tag: goal?.tag?.abbreviation || 'sl',
      attempts: goal?.attempts || { total: 0, this_month: 0 },
      description: goal?.title || 'Goal description not available'
    };
  }

  componentDidMount() {
    // Component is ready
  }

  _onGoalPress = () => {
    const { navigate } = this.props;
    console.log('GoalComponent _onGoalPress called with navigate:', navigate);
    
    if (navigate) {
      console.log('Navigating to /goals/individual/' + this.props.id + ' with goalId:', this.props.id);
      navigate(`/goals/individual/${this.props.id}`, { state: { goalId: this.props.id } });
    } else {
      // Fallback: use window.location or console log for debugging
      console.error('Navigate prop is undefined! Cannot navigate to goal individual screen.');
      console.log('Goal ID:', this.props.id);
      // You can implement fallback navigation here
    }
  }

  render() {
    const { tag, description } = this.state;
    const maxLimit = 90;

    // Render tag icon based on abbreviation - using actual SVG icons
    let tagIcon = null;
    switch (tag) {
      case "cog":
        tagIcon = <CogColorIcon className="tag-icon" />;
        break;
      case "fm":
        tagIcon = <FmColorIcon className="tag-icon" />;
        break;
      case "gm":
        tagIcon = <GmColorIcon className="tag-icon" />;
        break;
      case "ps":
        tagIcon = <PsColorIcon className="tag-icon" />;
        break;
      case "pw":
        tagIcon = <PwColorIcon className="tag-icon" />;
        break;
      case "se":
        tagIcon = <SeColorIcon className="tag-icon" />;
        break;
      case "sh":
        tagIcon = <ShColorIcon className="tag-icon" />;
        break;
      case "sl":
      default:
        tagIcon = <SlColorIcon className="tag-icon" />;
    }

    return (
      <div className="goal-list-item" onClick={this._onGoalPress}>
        <div className="goal-container">
          <div className="goal-icon">
            {tagIcon}
          </div>
          <div className="goal-description-container">
            {description.length > maxLimit ? (
              <div className="goal-content">
                <span className="goal-description">
                  {description.substring(0, maxLimit)}{" "}
                </span>
                <span className="goal-see-more">
                  See more...
                </span>
              </div>
            ) : (
              <div className="goal-content">
                <span className="goal-description">
                  {description}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  static getDerivedStateFromProps(nextProps: GoalComponentProps, prevState: GoalComponentState) {
    if (nextProps.currentSettings?.child?.goals) {
      const goal = nextProps.currentSettings.child.goals.find((obj: any) => obj.id === nextProps.id);
      if (goal) {
        return {
          attempts: goal.attempts,
          description: goal.title,
        };
      }
    }
    return null;
  }
}

const mapStateToProps = (state: any) => ({
  currentSettings: state.currentSettings,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GoalComponent);
